import styles from './PageContainer.module.css';
import { setupSWLayout as layout } from 'e3-common/utils/serviceWorkerRegistration';
import useFetch from 'e3-common/hooks/useFetch';
import React, { useState, useRef, useEffect } from 'react';
import { getCommonCodeById } from 'e3-common/utils/commonCodeUtil';
import { useBoundStore } from 'e3-common/store/useBoundStore';
import PropTypes from 'prop-types';
import { HOME_MENU_ID } from 'e3-common/constants/constMenuId';
import HelpPopup from '@/pages/System/Popup/HelpPopup';
import { shallow } from 'zustand/shallow';

const PageContainer = ({ children, menuName, menuId, helpYn, menuNameList }) => {
    const { favoriteMenu, setFavoriteMenu } = useBoundStore((state) => state.menu);
    const { selectedMenu } = useBoundStore((state) => state.menu, shallow);
    const stateAll = useBoundStore((state) => state);
    const [showMenuId, setShowMenuId] = useState(false);
    const [newMenuName, setNewMenuName] = useState(menuName);
    const { request } = useFetch();
    const refPopup = useRef();

    useEffect(() => {
        const checkSysOpt = async () => {
            const code = await getCommonCodeById('SYSTEM_OPTION', 'SYS_OPT_SHOW_MENU_ID');
            if (code?.propStr1 === 'Y') {
                setShowMenuId(true);
            }
        };
        checkSysOpt();
    }, []);

    const getFavoriteMenuState = (menuId) => {
        const menuList = favoriteMenu?.reduce((pre, cur) => {
            pre.push(cur.menuId ?? cur.MENU_ID);
            return pre;
        }, []);
        return menuList?.includes(menuId);
    };

    const onSetFavorite = async (menuId) => {
        const param = { MENU_ID: menuId };
        const response = await request(null, {
            ...param,
            serviceId: 'FavoriteMenuService',
            process: [{ saveFavorite: '즐겨찾는 메뉴 등록' }],
            isSystem: true,
        });
        if (response) {
            const camelResponse = response?.data?.result?.map((x) => {
                return {
                    isActive: x.IS_ACTIVE,
                    menuId: x.MENU_ID,
                    menuName: x.MENU_NM,
                    programPath: x.PGM_PATH,
                    programRoutePath: x.ROUTING_PATH,
                };
            });
            setFavoriteMenu(camelResponse);
        }
    };

    const openPopup = () => {
        refPopup.current.showPopup(menuId);
    };
    const v = layout();

    return (
        <>
            {menuId !== HOME_MENU_ID && v?.c ? (
                <h2 className={styles[v?.eptz]}>
                    {menuId && menuName ? (
                        <>
                            <div className={styles[v?.eptxz]}>
                                <MenuNameList menuNameList={menuNameList} />
                                <span>{showMenuId && ` (${menuId})`}</span>
                            </div>
                            <div className={styles[v?.epiz]}>
                                {helpYn === 'Y' && (
                                    <span className={styles.help} onClick={openPopup}>
                                        도움말<em className={styles[v?.ett]}>도움말</em>
                                    </span>
                                )}
                                {helpYn === 'Y' && <span className={styles[v?.eptb]}></span>}
                                <span
                                    className={`${styles.favorite} ${
                                        getFavoriteMenuState(menuId) && styles.selected
                                    }`}
                                    onClick={() => {
                                        onSetFavorite(menuId);
                                    }}
                                >
                                    즐겨찾기
                                    <em className={styles[v?.ett]}>즐겨찾기</em>
                                </span>
                            </div>
                        </>
                    ) : null}
                </h2>
            ) : null}
            {children}
            <HelpPopup ref={refPopup} />
        </>
    );
};

/**
 * @param {{ menuNameList?: string }} props
 * @returns {JSX.Element}
 */
function MenuNameList({ menuNameList = '' }) {
    const menus = menuNameList.split('>');
    return (
        <div className={styles.pageTitle_Map}>
            {menus.map((menu, i) => (
                <React.Fragment key={i}>
                    {menu}
                    {i !== menus.length - 1 && <i className="bi bi-chevron-right"></i>}
                </React.Fragment>
            ))}
        </div>
    );
}

PageContainer.propTypes = {
    children: PropTypes.node,
    menuName: PropTypes.string,
    menuId: PropTypes.string,
    menuNameList: PropTypes.string,
};
PageContainer.displayName = 'PageContainer';
export default PageContainer;
